export default function formatCurrency (number) {
  const formattedNumber = Number(number)
  return typeof (formattedNumber) === 'number' && !isNaN(formattedNumber) ? '$' + Number(number).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : undefined
}
